import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router-dom";
import ProductCard from "../../components/products/ProductCard";
import CategoryCard from "../../components/categories/CategoryCard";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import firebase from "firebase/app";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import CategoriesList from "../../components/categories/CategoriesList";
import StoreImage from "../../components/StoreImage";
import { algoliaClient } from "../../utils/constants";
import { useTheme } from "@mui/material/styles";
import CompareStoreItem from "../../components/compare/compareStoreItem";
import EmptyComponentRender from "../../components/EmptyComponentRender";
import Carousel from "react-material-ui-carousel";
import CardMedia from "@mui/material/CardMedia";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import { toast as Toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMinusCircle,
  faPlusCircle,
  faBalanceScaleRight,
  faLongArrowLeft,
  faLongArrowRight,
} from "@fortawesome/free-solid-svg-icons";
import { faHeart as faHeartNotFilled } from "@fortawesome/free-regular-svg-icons";
import Skeleton from "@mui/material/Skeleton";
import { makeStyles } from "@mui/styles/";
import Typography from "@mui/material/Typography";
import { addItemToCart } from "../../redux/reducers/cart.reducer";
import { setFavouriteProducts } from "../../redux/reducers/favouriteProducts.reducer";
import Toolbar from "@mui/material/Toolbar";
import FullScreenLoading from "../../components/FullScreenLoading";
import {isMobile} from "react-device-detect";
const useStyles = makeStyles({
  mainContainer: {
    padding: 20,
paddingTop:isMobile?60:20
    /// paddingTop: StatusBar.currentHeight
  },
  badgesContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    marginHorizontal: 20,
  },
  badge: {
    padding: 5,
    borderRadius: 25,
    alignSelf: "flex-start",
    marginHorizontal: 4,
    fontSize: 17,
    fontWeight: "bold",
  },
  arrow: {
    textAlign: "center",
    alignSelf: "center",
    fontWeight: "bold",
  },
  categories: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    marginTop: 20,
    marginHorizontal: 20,
  },
});

const CategoryScreen = ({}) => {
  const [loading, setLoading] = useState(false);
  const [selectedSubCategories, setSelectedSubCategories] = useState([]);
  const [searchRecords, setSearchRecords] = React.useState([]);
  const { t, i18n } = useTranslation();
  const styles = useStyles();
  const history = useHistory();
  const theme = useTheme();
  const params = useParams();
  const dispatch = useDispatch();
  const searchIndex = algoliaClient.initIndex("products");
  const [searchMode, setSearchMode] = React.useState(false);
  const handleSelect = (selected) => {
    setSelectedSubCategories([...selectedSubCategories, selected]);
  };
  const handleUnSelect = (categoryIndex) => {
    if (categoryIndex > 0) {
      const filteredSelected = selectedSubCategories.slice(0, categoryIndex);
      setSelectedSubCategories(filteredSelected);
    } else if (categoryIndex == 0) {
      setSelectedSubCategories([selectedSubCategories[0]]);
    }
  };
  const loadDataFromAlgolia = (searchValue) => {
    setLoading(true);
    searchIndex
      .search(searchValue)
      .then((results) => {
        setSearchRecords(results.hits);
        setLoading(false);
      })
      .catch((err) => {
        Toast.error("Could not retrieve any search records, Please try again later.");
        setLoading(false);
      });
  };
  useEffect(() => {
    setLoading(true);
    if (params?.id) {
      (async () => {
        const categoryId = params?.id;
        if (categoryId) {
          (async () => {
            firebase
              .firestore()
              .collection("categories")
              .doc(categoryId)
              .get()
              .then((result) => {
                if (result.exists) {
                  setSelectedSubCategories([result.data()]);
                }
                setLoading(false);
              })
              .catch((err) => {
                setLoading(false);
              });
          })();
        } else {
          setLoading(false);
        }
      })();
    }
  }, [params]);

  useEffect(() => {
    setLoading(true);
    if (
      selectedSubCategories &&
      selectedSubCategories.length > 0 &&
      (!selectedSubCategories[selectedSubCategories.length - 1].subCategories ||
        selectedSubCategories[selectedSubCategories.length - 1].subCategories
          .length <= 0)
    ) {
      loadDataFromAlgolia(
        selectedSubCategories[selectedSubCategories.length - 1].titleEn
      );
    } else {
      setSearchRecords([]);
      setLoading(false);
    }
  }, [selectedSubCategories.length]);

  if (loading) {
    return <FullScreenLoading />
  }

  return (
    <div style={{ flex: 1, backgroundColor: theme.light.white ,}}>
      <div className={styles.mainContainer} >
        <div className={styles.badgesContainer}>
          <Toolbar
            component="nav"
            variant="dense"
            sx={{ justifyContent: "space-between", overflowX: "auto" }}
          ><div
          style={{ display: "flex", flexDirection: "row" }}
          key={"category title"}
        >
               <Typography
                    className={styles.badge}
                    style={{
                      color: theme.light.dark,
                      textAlign: "center",
                      fontSize: 28,
                      alignSelf: "center",
                      cursor: "pointer",
                    }}
                    onClick={() => history.push("/")}
                  >
                    {t("home.categories")}
                  </Typography>
                  <FontAwesomeIcon
                        className={styles.arrow}
                        style={{
                          color: theme.light.dark,
                          marginRight: 10,
                          marginLeft: 10,
                        }}
                        size={20}
                        icon={
                          i18n.language == "ar"
                            ? faLongArrowLeft
                            : faLongArrowRight
                        }
                      />
                      </div>
            {selectedSubCategories &&
              selectedSubCategories.length > 0 &&
              selectedSubCategories.map((cat, index) => (
                <div
                  style={{ display: "flex", flexDirection: "row" }}
                  key={index}
                >
               
                  <Typography
                    className={styles.badge}
                    style={{
                      color: theme.light.dark,
                      textAlign: "center",
                      fontSize: 28,
                      alignSelf: "center",
                      cursor: "pointer",
                    }}
                    onClick={() => handleUnSelect(index)}
                  >
                    {i18n.language == "ar" ? cat.titleAr : cat.titleEn}
                  </Typography>
                  {selectedSubCategories.length > 1 &&
                    index != selectedSubCategories.length - 1 && (
                      <FontAwesomeIcon
                        className={styles.arrow}
                        style={{
                          color: theme.light.dark,
                          marginRight: 10,
                          marginLeft: 10,
                        }}
                        size={20}
                        icon={
                          i18n.language == "ar"
                            ? faLongArrowLeft
                            : faLongArrowRight
                        }
                      />
                    )}
                </div>
              ))}
          </Toolbar>
        </div>
        <div className={styles.categories}>
          {selectedSubCategories &&
            selectedSubCategories.length > 0 &&
            selectedSubCategories[selectedSubCategories.length - 1]
              .subCategories &&
            selectedSubCategories[selectedSubCategories.length - 1]
              .subCategories.length > 0 && (
              <Container maxWidth="lg">
                <Grid container spacing={isMobile?2:12}>
                  {selectedSubCategories[
                    selectedSubCategories.length - 1
                  ].subCategories.map((cat, index) => {
                    return (
                      <CategoryCard
                        key={index}
                        onSelect={() => handleSelect(cat)}
                        index={index}
                        title={
                          i18n.language == "ar" ? cat.titleAr : cat.titleEn
                        }
                      />
                    );
                  })}{" "}
                </Grid>
              </Container>
            )}
          {searchRecords && searchRecords.length > 0 && (
            <Container maxWidth="lg" style={{paddingTop:20}}>
              <Grid container spacing={12}>
                {searchRecords.map((item) => (
                  <ProductCard card={item} />
                ))}
              </Grid>
            </Container>
          )}
          {!loading &&
            searchRecords &&
            searchRecords.length <= 0 &&
            selectedSubCategories &&
            selectedSubCategories.length > 0 &&
            (!selectedSubCategories[selectedSubCategories.length - 1]
              .subCategories ||
              selectedSubCategories[selectedSubCategories.length - 1]
                .subCategories.length <= 0) && <EmptyComponentRender />}
        </div>
      </div>
    </div>
  );
};

export default CategoryScreen;
